import { render, staticRenderFns } from "./ServiceFormStep.PD-10913.vue?vue&type=template&id=be5b6b52"
import script from "./ServiceFormStep.PD-10913.vue?vue&type=script&lang=js"
export * from "./ServiceFormStep.PD-10913.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports